import React, { Component } from 'react'
import Domain from '../../../../_Components/Domain'
import Preview from '../../../../_Components/Preview'
import Pending from '../../../../_Components/Pending'
import Biography from '../../../../_Components/Biography'
import httpStatus from 'http-status'
import ContainerFluid from '../../../../../../_layouts/ContainerFluid'

import { connect } from 'react-redux'
import { history } from '../../../../../../_helpers/history'
import { Col, Row } from 'react-bootstrap'
import { userActions } from '../../../../../../_actions/user.actions'
import { userService } from '../../../../../../_services/user.service'
import { alertActions } from '../../../../../../_actions/alert.actions'
import { doctorService, doctorService as licensedService } from '../../../../../../_services/doctor.service'

const PERSONALIZED_DOMAIN = 'PERSONALIZED_DOMAIN'
const BIOGRAPHY = 'BIOGRAPHY'
const PREVIEW = 'PREVIEW'
const PENDING = 'PENDING'

class SetupProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bio: '',
      domain: `${props.currentUser.FirstName.toLowerCase()}-${props.currentUser.LastName.toLowerCase()}`,
      profileImage: !props.currentUser.ProfileUrl.includes('profile') ? props.currentUser.profileUrlSizes.lrg : null,
      step: props.currentUser.Doctor.landingPage.status === 'PENDING' ? PENDING : PERSONALIZED_DOMAIN,
      steps: [
        { title: 'Personalized Domain', status: 'current' },
        { title: 'Biography', status: 'incomplete' },
        { title: 'Preview', status: 'incomplete' }
      ],
      errors: false,
      uploading: false,
      publishing: false,
      updateRequest: false
    }

    this.userInterval = null

    this.handleProfile = this.handleProfile.bind(this);
    this.handleSetState = this.handleSetState.bind(this)
    this.handleNextStep = this.handleNextStep.bind(this)
    this.handlePreviousStep = this.handlePreviousStep.bind(this)
    this.handlePublishProfile = this.handlePublishProfile.bind(this)
    this.handleValidateDomain = this.handleValidateDomain.bind(this)
    this.handleDisplayPending = this.handleDisplayPending.bind(this)
  }

  componentDidMount() {
    const { id } = history.location.state

    this.handleValidateDomain(this.state.domain)

    if (id) {
      doctorService.getLandingById(id)
        .then(licensed => {
          this.setState({
            id: id,
            domain: `${licensed.firstName.toLowerCase()}-${licensed.lastName.toLowerCase()}`,
            status: licensed.status,
            loading: false,
            licensed: licensed,
            profileImage: !licensed.profileUrl.includes('profile') ? licensed.profileUrl : null
          })
        })
        .catch(() => {
          history.push('/account/users/view-licensed#landing')
          this.props.dispatch(alertActions.error('An error occured and we could not set up this landing page at this time.'));
        })
    }
    else {
      history.push('/account/users/view-licensed#landing')
      this.props.dispatch(alertActions.error('An error occured and we could not set up this landing page at this time.'));
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentUser.ProfileUrl !== this.props.currentUser.ProfileUrl) {
      this.setState({
        profileImage: this.props.currentUser.profileUrlSizes.lrg
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.userInterval)
  }

  handleSetState(value) {
    this.setState(value)
  }

  handleNextStep() {
    this.props.dispatch(alertActions.clear())

    switch (this.state.step) {
      case PERSONALIZED_DOMAIN:
        return this.setState({
          step: BIOGRAPHY, steps: [
            { title: 'Personalized Domain', status: 'complete' },
            { title: 'Biography', status: 'current' },
            { title: 'Preview', status: 'incomplete' }
          ],
        })
      case BIOGRAPHY:
        return this.setState({
          step: PREVIEW, steps: [
            { title: 'Personalized Domain', status: 'complete' },
            { title: 'Biography', status: 'complete' },
            { title: 'Preview', status: 'current' }
          ],
        })
      case PREVIEW:
        return this.handlePublishProfile()
      default: return null
    }
  }

  handlePreviousStep() {
    this.props.dispatch(alertActions.clear())
    switch (this.state.step) {
      case PERSONALIZED_DOMAIN:
        return history.push('/account/users/view-licensed#landing')
      case BIOGRAPHY:
        return this.setState({
          step: PERSONALIZED_DOMAIN, steps: [
            { title: 'Personalized Domain', status: 'current' },
            { title: 'Biography', status: 'incomplete' },
            { title: 'Preview', status: 'incomplete' }
          ],
        })
      case PREVIEW:
        return this.setState({
          step: BIOGRAPHY, steps: [
            { title: 'Personalized Domain', status: 'complete' },
            { title: 'Biography', status: 'current' },
            { title: 'Preview', status: 'incomplete' }
          ],
        })
      default: return null
    }
  }

  handleValidateDomain(domain) {
    let errors = false
    const domainRegEx = /^[a-z](?:-?[a-z0-9]+)*$/

    if (domain.length === 0) {
      errors = { domain: 'Please enter a domain.' }
    }

    if (!domainRegEx.test(domain)) {
      errors = { domain: 'The domain must begin with a letter, may include numbers and dashes, and can not end with a dash.' }
    }

    this.setState({ domain: domain, errors: errors })
  }

  handleProfile(base64Image) {
    this.setState({ uploading: true })

    userService.updateUserImage(base64Image)
      .then((data) => {
        this.props.dispatch(userActions.getCurrentUser());
        this.setState({
          uploading: false,
          profileImage: data.profileUrl,
          licensed: {
            ...this.state.licensed,
            profileUrl: data.profileUrl
          }
        })
      })
      .catch((error) => {
        this.props.dispatch(alertActions.error('An error occured and we could not update your profile photo at this time.'));
        this.setState({ uploading: false })
      })
  }

  handlePublishProfile() {
    if (!this.state.bio) {
      window.scrollTo(0, 0)
      this.props.dispatch(alertActions.error('Please add a bio to your profile.'))
    } else if (!this.state.profileImage) {
      window.scrollTo(0, 0)
      this.props.dispatch(alertActions.error('Please upload a profile photo.'))
    } else {
      this.setState({ publishing: true })
      licensedService.enableLanding(this.state.bio, this.state.domain)
        .then(data => {
          this.setState({
            step: PENDING, steps: [
              { title: 'Personalized Domain', status: 'complete' },
              { title: 'Biography', status: 'complete' },
              { title: 'Preview', status: 'complete' }
            ],
            publishing: false
          })
          this.props.dispatch(userActions.setCurrentUser({
            ...this.props.currentUser,
            Doctor: {
              ...this.props.currentUser.Doctor,
              landingPage: {
                ...data.landingPage
              }
            }
          }));
          this.handleDisplayPending()
        })
        .catch(error => {
          if (error.response && error.response.status === httpStatus.UNPROCESSABLE_ENTITY) {
            this.setState({
              step: 'domain' in error.response.data ? PERSONALIZED_DOMAIN : BIOGRAPHY,
              errors: error.response.data
            });
          } else {
            this.props.dispatch(alertActions.error('We could not enable your landing page. Please try again.'));
          }
          window.scrollTo(0, 0)
          this.setState({ publishing: false });
        });
    }
  }

  handleDisplayPending() {
    this.userInterval = setInterval(() => {
      doctorService.getLandingById(this.state.id)
        .then((response) => {
          if (response.status === 'ACTIVE') {
            history.push('/account/users/view-licensed#landing')
            this.props.dispatch(alertActions.success('Your landing page was successfully created! Start by sharing your landing page domain or QR code.'))
          }
        })
    }, 1500);
  }

  render() {
    return <ContainerFluid>
      <Row>
        <Col xs={{ span: 10, offset: 1 }}>
          <Domain
            step={this.state.step}
            steps={this.state.steps}
            errors={this.state.errors}
            domain={this.state.domain}
            profileImage={this.state.profileImage}
            stepBack={this.handlePreviousStep}
            stepForward={this.handleNextStep}
            validateDomain={this.handleValidateDomain}
          />

          <Biography
            step={this.state.step}
            bio={this.state.bio}
            steps={this.state.steps}
            errors={this.state.errors}
            setValue={this.handleSetState}
            stepBack={this.handlePreviousStep}
            stepForward={this.handleNextStep}
          />

          <Preview
            step={this.state.step}
            bio={this.state.bio}
            steps={this.state.steps}
            domain={this.state.domain}
            client={this.props.client}
            licensed={this.state.licensed}
            uploading={this.state.uploading}
            publishing={this.state.publishing}
            profileImage={this.state.profileImage}
            stepBack={this.handlePreviousStep}
            stepForward={this.handleNextStep}
            handleProfile={this.handleProfile}
          />

          <Pending step={this.state.step} />

        </Col>
      </Row>

    </ContainerFluid>
  }
}

function mapStateToProps(state) {
  return {
    client: state.client,
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps)(SetupProfile);
